import { ApiUtils } from '@/utils/ApiUtils'
import { resetState } from '@/utils/Storage'
const moment = require('moment')

const initialState = () => {
  return {
    globalSaving: false,
    summaryEvent: null,
    currentEvent: null,
    currentDate: moment().format('YYYY-MM-DD'),
    currentClient: null,
    attentionSummaryDrawer: false,
    loading: false
  }
}

export default {
  namespaced: true,
  state: {
    ...initialState()
  },
  mutations: {
    reset: (state) => {
      const s = initialState()
      resetState(state, s);
    },
    showAttentionSummaryDrawer(state, event){
      if(event) state.summaryEvent = event
      state.attentionSummaryDrawer = true
    },
    hideAttentionSummaryDrawer(state){
      state.attentionSummaryDrawer = false
    },
    setGlobalSaving(state, saving) {
      state.globalSaving = saving
    },
    setEvent(state, evt) {
      state.currentEvent = evt
    },
    setDate(state, date){
      state.currentDate = date
    },
    setCurrentClient(state, client){
      state.currentClient = client
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },
  actions: {
    async loadScheduleEventDetails(ctx, payload) {

      const currentEvent = payload.eventId

      if(!currentEvent) return
      const response = await ApiUtils.makeGet(`schedule/event/${currentEvent}`)

      if(!response.ok){
        const json = await response.json()
        ctx.commit('showSnackBar', (json.message || 'Ha ocurrido un error intentando consultar los datos'))
        return
      }

      const json = await response.json()
      const eventDetails = JSON.parse(JSON.stringify(json.result.event))
      ctx.commit('setEvent', eventDetails)

    }
  },
  getters: {
    loading: state => state.loading,
    event: state => state.currentEvent
  }
}
